// Centralized constants for Evidence Review dialog

export const LABELS = {
  photos: 'Photos',
  witnesses: 'Witnesses',
  policeReport: 'Police Report',
  ems: 'EMS / Ambulance',
  medicalTreatment: 'Medical Treatment',
  insurance: 'Insurance',
  lostWages: 'Lost Wages',
  financialImpact: 'Financial Impact',
} as const;

export const SECTIONS = {
  liability: ['photos', 'witnesses', 'policeReport'],
  treatment: ['ems', 'medicalTreatment'],
  coverage: ['insurance'],
} as const;
